<template>
  <DialogPrime
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    header="Editar Contratos de Usuario"
    :modal="true"
    :style="{ width: '80vw' }"
  >
    <DataTable :value="detallesContrato" :paginator="true" :rows="10" :rowsPerPageOptions="[5,10,20]" responsiveLayout="scroll">
      <Column field="id" header="ID"></Column>
      <Column field="curso" header="Curso"></Column>
      <Column field="asignatura" header="Asignatura"></Column>
      <Column field="fechaInicio" header="Fecha Inicio"></Column>
      <Column field="fechaFin" header="Fecha Fin"></Column>
      <Column field="estado" header="Estado"></Column>
      <Column header="Acciones">
        <template #body="slotProps">
          <ButtonPrime icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" @click="editarDetalleContrato(slotProps.data)" />
          <ButtonPrime icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="eliminarDetalleContrato(slotProps.data)" />
        </template>
      </Column>
    </DataTable>
    <template #footer>
      <ButtonPrime label="Agregar Contrato" icon="pi pi-plus" @click="agregarNuevoContrato" />
      <ButtonPrime label="Cerrar" icon="pi pi-times" @click="cerrar" />
    </template>
  </DialogPrime>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import DialogPrime from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ButtonPrime from 'primevue/button';
import usuarioService from '@/services/UsuarioService';

export default {
  name: 'ContratoUsuarioDialog',
  components: {
    DialogPrime,
    DataTable,
    Column,
    ButtonPrime,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    usuarioId: {
      type: Number,
      required: true,
    },
  },
  emits: ['update:visible', 'contrato-actualizado'],
  setup(props, { emit }) {
    const detallesContrato = ref([]);

   /* const cargarDetallesContrato = async () => {
      try {
        const response = await usuarioService.getDetallesContrato(props.usuarioId);
        detallesContrato.value = response.data;
      } catch (error) {
        console.error('Error al obtener detalles de contrato:', error);
        // Manejar el error (mostrar un mensaje al usuario, por ejemplo)
      }
    };*/

    onMounted();

    watch();

    const editarDetalleContrato = (detalle) => {
      // Lógica para editar un detalle de contrato
      console.log('Editar detalle:', detalle);
      // Aquí podrías abrir otro diálogo para editar el detalle específico
    };

    const eliminarDetalleContrato = async (detalle) => {
      try {
        await usuarioService.eliminarDetalleContrato(detalle.id);
        detallesContrato.value = detallesContrato.value.filter(d => d.id !== detalle.id);
        emit('contrato-actualizado');
      } catch (error) {
        console.error('Error al eliminar detalle de contrato:', error);
        // Manejar el error
      }
    };

    const agregarNuevoContrato = () => {
      // Lógica para agregar un nuevo contrato
      console.log('Agregar nuevo contrato para usuario:', props.usuarioId);
      // Aquí podrías abrir otro diálogo para agregar un nuevo detalle de contrato
    };

    const cerrar = () => {
      emit('update:visible', false);
    };

    return {
      detallesContrato,
      editarDetalleContrato,
      eliminarDetalleContrato,
      agregarNuevoContrato,
      cerrar,
    };
  },
};
</script>
